export enum AsCsReceiptStatus {
  REQUEST = 'REQUEST',
  INPROGRESS = 'INPROGRESS',
  COMPLETE = 'COMPLETE',
  CANCEL = 'CANCEL',
}

export enum AsCsReceiptType {
  VISIT = 'VISIT',
  EMAIL = 'EMAIL',
  ETC = 'ETC',
  CALL = 'CALL',
}

export enum AsCsProcessType {
  REPLACE = 'REPLACE',
  REPAIR = 'REPAIR',
  CHECK = 'CHECK',
  ETC = 'ETC',
}

export enum AsCsChargeType {
  PAID = 'PAID',
  FREE = 'FREE',
}
